import * as Styled from "./styled";
import { useParams } from "react-router-dom";
import { ServicesContext } from "../../context/ContextServices/context";
import { useContext } from "react";

const Servico = () => {
  const { id } = useParams();
  const { state } = useContext(ServicesContext);

  const service = state.services.find((s: any) => String(s.id) === String(id));

  if (!service) {
    return <p>Carregando...</p>;
  }

  const dataFormatada = service.dataSaida
    ? service.dataSaida.split("-").reverse().join("/")
    : "Não informada";

  const converterValor = (valor: any): number => {
  if (valor === null || valor === undefined || valor === "") {
    return 0;
  }

  // Se já for número
  if (typeof valor === "number") {
    return isNaN(valor) ? 0 : valor;
  }

  // Se for string
  const valorConvertido = Number(
    String(valor)
      .replace("R$", "")
      .replace(/\s/g, "")
      .replace(/\./g, "")
      .replace(",", ".")
  );

  return isNaN(valorConvertido) ? 0 : valorConvertido;
};

const totalPecas =
  service.extras?.pecaLoja_extra?.reduce(
    (total: number, item: any) => total + converterValor(item.valorVenda),
    0
  ) ?? 0;
    

  return (
    <Styled.Container>
      <Styled.Card>
        <span
          style={{
            fontSize: "16px",
            fontWeight: "bolder",
            backgroundColor: "#166534",
            padding: "5px 10px",
            borderRadius: "5px",
            color: "#fff",
          }}
        >
          Data de Saída: {dataFormatada && dataFormatada !== "Não informada"
            ? dataFormatada
            : "Não informada"}
        </span>

        <Styled.Header>
          <h1>Detalhes do Serviço</h1>

          <Styled.Status $status={service.status}>
            {service.status}
          </Styled.Status>
        </Styled.Header>

        <Styled.ImagesContent>
          {(Array.isArray(service.foto)
            ? service.foto
            : [service.foto]
          ).map((foto: any, index: number) =>
            foto ? (
              <Styled.Image
                key={index}
                src={foto}
                alt={`Foto ${index + 1}`}
              />
            ) : null
          )}
        </Styled.ImagesContent>

        <Styled.Grid>
          <Styled.Item>
            <span>Cliente</span>
            <strong>{service.nomeCliente}</strong>
          </Styled.Item>

          <Styled.Item>
            <span>Telefone</span>
            <strong>{service.telefone}</strong>
          </Styled.Item>

          <Styled.Item>
            <span>Modelo</span>
            <strong>{service.modeloMoto}</strong>
          </Styled.Item>

          <Styled.Item>
            <span>Placa</span>
            <strong>{service.placa}</strong>
          </Styled.Item>

          <Styled.Item>
            <span>Tipo</span>
            <strong>{service.tipoConserto}</strong>
          </Styled.Item>

          <Styled.Item>
            <span>Valor</span>
            <strong>R$ {service.valorConserto}</strong>
          </Styled.Item>

          <Styled.Item>
            <span>Observações</span>
            <strong>{service.observacoes || "Nenhuma observação."}</strong>
          </Styled.Item>

          <Styled.Item>
            <span>Peças da Loja</span>

            {service.extras?.pecaLoja_extra?.length ? (
    <>
      <ul style={{ paddingLeft: "20px", margin: 0 }}>
        {service.extras.pecaLoja_extra.map((item: any, index: number) => {
          const valor = converterValor(item.valorVenda);

          return (
            <li key={index} style={{ margin: "5px 0" }}>
              {item.produto} -{" "}
              {valor.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </li>
          );
        })}
      </ul>

      <span
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          display: "block",
          marginTop: "10px",
        }}
      >
        Valor total:{" "}
        {totalPecas.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        })}
      </span>
    </>
  ) : (
    <p>Nenhuma peça da loja adicionada.</p>
  )}
          </Styled.Item>
        </Styled.Grid>
      </Styled.Card>
    </Styled.Container>
  );
};

export default Servico;